<template>
  <div>
    <div class="container">
      <el-breadcrumb class="hsb-breadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>机型选择</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container models-view">
      <div class="choose-model-tip" @mouseover="showLockGuide=true" @mouseout="showLockGuide=false">
        <span>如何查看手机型号</span>
        <img src="https://www.huishoubao.com/static/pc/common/img/icon_q2.png">
        <div class="unlock-guide" v-show="showLockGuide">
          <p>安卓用户： 前往“设置>关于手机”，然后查看您设备的相关信息。</p>
          <p>苹果用户：</p>
          <p>方法一： 苹果手机背面有型号信息</p>
          <p>方法二： 前往“设置>通用>监管”，然后查看您设备的相关信息。</p>
        </div>
      </div>
      <model
        :products="products"
        :brands="brands"
        :currentBrand="currentBrandId"
        :categories="categories"
        :currentCategory="currentClassId"
        @categoryClick="handeCategory"
        @brandClick="handleBrand"
        @productClick="productTap"
        :show-logo="!isM"
        :loading="pageloading"
        @infinite="infiniteHandler"
        :infinite-load="isM"
        :show-cate="!isM"
        product-img
        ></model>
      <pagination class="text-center h-pagination" v-if="!isM && pageInfo.totalPage > 1" :page-size="+pageInfo.pageSize" layout="prev, pager, next" :current-page="+pageInfo.pageIndex" @current-change="handleCurrentChange" :total="+pageInfo.total"></pagination>
    </div>
  </div>
</template>

<script>
import ModelStore from '@/core/models/store';
import superModel from '@/core/models/superModel';
import Search from '@/core/search/search';
import searchStore from '@/core/search/store';
import isMobile from 'ismobilejs';
import { Breadcrumb, BreadcrumbItem, Pagination, Popover } from 'element-ui';

export default {
  extends: superModel,
  components: {
    Search,
    Pagination,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Popover.name]: Popover
  },
  asyncData: (...arg) => {
    return superModel.asyncData(...arg, 24);
  },
  data () {
    return {
      isM: false,
      productPageSize: 24,
      showLockGuide: false
    };
  },
  registerModule (store, preserveState) {
    store.registerModule('models', ModelStore, { preserveState });
    store.registerModule('search', searchStore, { preserveState });
  },
  destroyed () {
    this.$store.unregisterModule('models');
    this.$store.unregisterModule('search');
  },
  methods: {
    updateKey (e) {
      this.$store.dispatch('search/setKey', e.target.value);
    },
    showMoreSearch (key) {
      this.$router.push(`/search?key=${key}`);
    }
  },
  mounted () {
    this.isM = isMobile.phone;
    // this.$store.dispatch('search/setKey', '');
  }
};
</script>

<style src="./models.css" scoped></style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/models/models.vue